// Boat yard entry/exit documents (Service, Documents). A small log of boats arriving at or leaving the
// yard, holding the fields that fill the printable ΕΝΤΥΠΟ ΕΙΣΑΓΩΓΗΣ / ΕΞΑΓΩΓΗΣ ΣΚΑΦΟΥΣ forms. D1-backed;
// the worker validates and the SPA reuses the schema. One row per boat record; either date may stay
// blank until it happens (a boat is logged on arrival, its exit date filled in later).
// A record filled in from a vessel's Entry form button on the Service page is kept with that vessel: it
// carries the Smartsheet row id of the vessel's row (serviceRowId). One made on the Documents page has none.
// That record is the vessel's Vessel Entry & Work Control Form: the rest of the form beyond these columns
// is its control part (vesselEntry.ts), JSON in the control column. Records without one are the plain
// entry/exit records, printed as before.
import { z } from 'zod';
import { VesselEntryControlSchema } from './vesselEntry.js';
export const BoatDocInputSchema = z
    .object({
    id: z.number().int().positive().optional(),
    boatName: z.string().max(160).optional().default(''),
    model: z.string().max(80).optional().default(''), // Μοντέλο
    sap: z.string().max(40).optional().default(''),
    phone: z.string().max(60).optional().default(''),
    hin: z.string().max(80).optional().default(''),
    entryDate: z.string().max(20).optional().default(''), // YYYY-MM-DD
    exitDate: z.string().max(20).optional().default(''), // YYYY-MM-DD
    note: z.string().max(1000).optional().default(''),
    // the Service vessel's row id. Left out, an edit keeps the link the record already has (the Documents
    // page never sends it); '' takes the record off its vessel.
    serviceRowId: z.string().regex(/^\d{0,20}$/, 'A Service vessel is a row number').optional(),
    // the rest of the Vessel Entry & Work Control Form. Left out, an edit keeps what the record has (the
    // Documents page edits only the columns above)
    control: VesselEntryControlSchema.optional(),
    // an edit's copy of the record (its updatedAt as loaded): sent, the edit is turned away if someone saved
    // the record since, rather than writing over their change (a vessel's entry form sends it)
    updatedAt: z.string().max(40).optional(),
})
    .refine((o) => !!(o.boatName.trim() || o.hin.trim()), {
    message: 'A boat name or HIN is required',
    path: ['boatName'],
});
export const BoatDocIdSchema = z.object({ id: z.number().int().positive() });
//# sourceMappingURL=boatDocs.js.map